<template>
  <nav class="Breadcrumbs"
    :class="{
      'Breadcrumbs--large': large
    }">

    <icon class="Breadcrumbs-lockIcon"
      v-if="showLock"
      name="lock"
      width="11px"
      height="11px" />

    <template v-for="(item, index) in items">

      <span class="Breadcrumbs-divider Breadcrumbs-leadingCaret t-caps-md"
        v-if="leadingCaret">›</span>

      <component class="Breadcrumbs-item"
        :is="item.route ? 'router-link' : 'span'"
        :to="item.route"
        :class="{
          't-caps-md': !item.large,
          't-heading-caps': item.large,
          'Breadcrumbs-item--isLarge': item.large
        }">
        {{ item.title }}
      </component>

      <span class="Breadcrumbs-divider t-caps-md"
        v-if="index < items.length - 1 || trailingCaret">›</span>

    </template>

  </nav>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    },
    leadingCaret: {
      type: Boolean,
      default: false
    },
    trailingCaret: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    showLock: { // show lock icon?
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
@import 'properties';

.Breadcrumbs {
  display: inline-flex;
  align-items: baseline;
  font-family: var(--font-family-sans);
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.15em;
}

.Breadcrumbs-showLock {

}

.Breadcrumbs-lockIcon {
  margin-right: var(--unit-025);
}

.Breadcrumbs-lockIcon svg {
  fill: var(--c-grey-lt) !important;
}

.Breadcrumbs-item {
  text-decoration: none;
}

.Breadcrumbs-item--isLarge {
  font-size: 24px;
}

.Breadcrumbs-divider {
  margin: 0 var(--unit-025);
}

.Breadcrumbs-leadingCaret {
  /*margin-left: var(--unit-05);*/
}
</style>



// WEBPACK FOOTER //
// Breadcrumbs.vue?15f9ac35